module.exports = __webpack_public_path__ + "static/img/echart1.71d2211a.png";